const BarcodePatternIdentifierService = {

  patternCodesNexa: ['0518100', '6081163', '6157800', '6157811', '6157812', '6157813'],
  patterncodesGL: ['02', '04', '08', '06', '01', '03', '07', '09'],

  patterncodeAS: ['31', '33', '30', '32'],

  monthsNames: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'],

  patternCodes: {
    NEXA: 'NEXA',
    GL: 'GL',
    AS: 'AS'
  },

  providerNameAS: {
    "31": "Zinco Ligas",
    "33": "Teodoro e Moraes"
  },

  providerNameGL: {
    "02": "Latasa",
    "04": "Zinco Ligas",
    "08": "Teodoro e Moraes",
    "06": "Sul Óxido"
  },

  getProviderNameByCode(providerCode, patternCode) {
    switch (patternCode) {
      case this.patternCodes.AS:
        return this.providerNameAS[providerCode]
      case this.patternCodes.GL:
        return this.providerNameGL[providerCode]
      default:
        break;
    }
  },

  identify(barcode) {
    if (!barcode || barcode.length !== 28) {
      throw { isBarcodeError: true, message: 'Código de barras inválido.' }
    }

    const importedEpcPattern = /X/g

    if (importedEpcPattern.test(barcode)) {
      barcode = barcode.replace(importedEpcPattern, 0)
      this.isImportedByEpc = true
    }

    for (let pattern of this.patternCodesNexa) {
      const patternCodeNexa = new RegExp(`^${pattern}.+`, 'gm')
      if (patternCodeNexa.test(barcode)) {
        return this.getBarcodeDataByNexaPattern(barcode)
      }
    }

    for (let pattern of this.patterncodesGL) {
      if (pattern == barcode.slice(0, 2)) {
        return this.getBarcodeDataByGLPattern(barcode)
      }
    }

    for (let pattern of this.patterncodeAS) {
      if (pattern == barcode.slice(0, 2)) {
        return this.getBarcodeDataByASPattern(barcode)
      }
    }

    throw { isBarcodeError: true, message: 'Código de barras inválido.' }
  },

  getBarcodeDataByNexaPattern(barcode) {
    const barcodeData = {
      reference: null,
      lot: null,
      month: null,
      year: null,
      manufactureDate: null,
      volumeNumber: null,
      weight: null,
      quantity: null,
      patternCode: this.patternCodes.NEXA,
      providerName: 'Nexa'
    }

    barcodeData.monthIndexN = barcode.slice(9, 11)
    barcodeData.reference = barcode.slice(0, 7)
    barcodeData.year = `20${barcode.slice(7, 9)}`
    barcodeData.month = barcode.slice(9, 11)
    barcodeData.manufactureDate = `${barcodeData.month}/${barcodeData.year}`
    barcodeData.friendlyLot = `${barcodeData.month}/${barcodeData.year}`
    barcodeData.lot = barcode.slice(11, 17)
    barcodeData.volumeNumber = barcode.slice(17, 21) //jumbo
    barcodeData.weight = barcode.slice(21, 25)
    barcodeData.quantity = barcode.slice(25, 28) // always 000 for this pattern

    return barcodeData
  },

  getBarcodeDataByGLPattern(barcode) {
    const barcodeData = {
      providerCode: null,
      year: null,
      month: null,
      reference: null,
      weight: null,
      aluminiumPercentage: null,
      zincPercentage: null,
      siliconPercentage: null,
      ironPercentage: null,
      friendlyLot: null,
      patternCode: this.patternCodes.GL,
      manufactureDate: null,
      providerName: null
    }

    barcodeData.providerCode = barcode.slice(0, 2)
    barcodeData.providerName = this.getProviderNameByCode(barcodeData.providerCode, this.patternCodes.GL)
    barcodeData.year = `20${barcode.slice(2, 4)}`
    barcodeData.month = barcode.slice(4, 6)
    barcodeData.manufactureDate = `${barcodeData.month}/${barcodeData.year}`
    barcodeData.reference = barcodeData.providerCode
    barcodeData.lot = barcode.slice(6, 12)
    barcodeData.weight = barcode.slice(12, 16)
    barcodeData.aluminiumPercentage = barcode.slice(16, 19) / 10
    barcodeData.zincPercentage = barcode.slice(19, 22) / 10
    barcodeData.siliconPercentage = barcode.slice(22, 25) / 100
    barcodeData.ironPercentage = barcode.slice(25, 28) / 100

    if (this.isImportedByEpc) {
      barcodeData.aluminiumPercentage = barcodeData.aluminiumPercentage.toFixed(1).replace(/.$/g, "X")
      barcodeData.zincPercentage = barcodeData.zincPercentage.toFixed(1).replace(/.$/g, "X")
      barcodeData.siliconPercentage = barcodeData.siliconPercentage.toFixed(2).replace(/.$/g, "X")
      barcodeData.ironPercentage = barcodeData.ironPercentage.toFixed(2).replace(/^./g, "X")
    }

    return barcodeData
  },

    getDateByBarcodeEpc(barcode, epc) {
      const barcodeData = {
        year: null,
        month: null,
        manufactureDate: null,
      };

      let yearStartIndex, monthStartIndex;

      switch (epc.substring(0, 2)) {
        case '31':
          yearStartIndex = 7;
          monthStartIndex = 9;
          break;
        case '32':
        case '33':
          yearStartIndex = 2;
          monthStartIndex = 4;
          break;
        default:
          return null;
      }

      barcodeData.year = barcode.slice(yearStartIndex, yearStartIndex + 2);
      barcodeData.month = barcode.slice(monthStartIndex, monthStartIndex + 2);
      barcodeData.manufactureDate = `${barcodeData.month}/${barcodeData.year}`;

      return barcodeData;
    },

  getBarcodeDataByASPattern(barcode) {
    const barcodeData = {
      providerCode: null,
      year: null,
      month: null,
      reference: null,
      weight: null,
      aluminiumPercentage: null,
      numberOfpiece: null,
      siliconPercentage: null,
      ironPercentage: null,
      friendlyLot: null,
      patternCode: this.patternCodes.AS,
      manufactureDate: null
    }

    barcodeData.providerCode = barcode.slice(0, 2)
    barcodeData.providerName = this.getProviderNameByCode(barcodeData.providerCode, this.patternCodes.AS)
    barcodeData.year = `20${barcode.slice(2, 4)}`
    barcodeData.month = barcode.slice(4, 6)
    barcodeData.friendlyLot = `${barcodeData.month}/${barcodeData.year}`
    barcodeData.reference = barcodeData.providerCode
    barcodeData.lot = barcode.slice(6, 12)
    barcodeData.manufactureDate = `${barcodeData.month}/${barcodeData.year}`
    barcodeData.weight = barcode.slice(15, 19)
    barcodeData.aluminiumPercentage = barcode.slice(19, 22) / 10
    barcodeData.numberOfpiece = barcode.slice(12, 15)
    barcodeData.siliconPercentage = barcode.slice(22, 25) / 10
    barcodeData.ironPercentage = barcode.slice(25, 28) / 100

    if (this.isImportedByEpc) {
      barcodeData.aluminiumPercentage = barcodeData.aluminiumPercentage.toFixed(1).replace(/.$/g, "X")
      barcodeData.siliconPercentage = barcodeData.siliconPercentage.toFixed(1).replace(/.$/g, "X")
      barcodeData.ironPercentage = barcodeData.ironPercentage.toFixed(2).replace(/^./g, "X")
    }

    return barcodeData
  }
}

export default BarcodePatternIdentifierService



// WEBPACK FOOTER //
// ./src/component/Asset/barcode/BarcodePatternIdentifier.js